module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list-wrapper list-wrapper-hook"
  }, [_c('div', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isScrollable),
      expression: "isScrollable"
    }],
    staticClass: "top-tip"
  }, [_c('span', {
    staticClass: "pull-icon",
    class: _vm.pullDownClass
  }), _vm._v(" "), _c('span', {
    staticClass: "refresh-hook refresh-text",
    domProps: {
      "textContent": _vm._s(_vm.pullDownText)
    }
  })]), _vm._v(" "), _vm._t("default"), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isNeedLoadMore && _vm.isScrollable),
      expression: "isNeedLoadMore && isScrollable"
    }],
    staticClass: "bottom-tip"
  }, [_c('span', {
    staticClass: "pull-icon",
    class: _vm.pullUpClass
  }), _vm._v(" "), _c('span', {
    staticClass: "loading-hook loading-text",
    domProps: {
      "textContent": _vm._s(_vm.pullUpText)
    }
  })])], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isRefreshSuccess),
      expression: "isRefreshSuccess"
    }],
    staticClass: "alert",
    class: {
      success: _vm.isRefreshSuccess, error: !_vm.isRefreshSuccess
    },
    domProps: {
      "textContent": _vm._s(_vm.isRefreshSuccess ? _vm.pullDownConfig.refreshSuccess : _vm.pullDownConfig.refreshError)
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c459ee96"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/util/JPull.vue
// module id = 239
// module chunks = 1